import { FlexFileError } from './FlexFileError';

import {ReportDataService} from '../../report-data.service';

export class WBSAllocationError extends FlexFileError {

  protected reportService: ReportDataService;

  constructor(reportService: ReportDataService) {
    super(reportService, 'WBS Item Needs Allocation', 'WBS_ALLOCATION', 0, false, null);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/errors/WBSAllocationError.ts